import React from 'react';

import Button from '../components/Button';

export const DEFAULT_OPTION_NAME = 'default';

export function optionTree(brandToken, product, parentToken) {
  if (!product || !product.options || product.options === 0) return (null);

  parentToken = parentToken || '';

  let ret = product.options
    .filter((productOption) => {
      let myParent = productOption.parent_token || '';
      return (myParent === parentToken);
    })
    .map((productOption) => {
      let children = optionTree(brandToken, product, productOption.token);

      let color;
      if (productOption.color && productOption.color.rgb && productOption.color.rgb !== '') {
        let rgbColor = productOption.color.rgb;
        if (rgbColor.length > 0 && rgbColor[0] !== '#') rgbColor = '#' + rgbColor;
        color = <span className="oval" style={{backgroundColor: rgbColor}}/>
      }

      return (
        <div key={productOption.token} className="product-option-block">
          <div className="product-option">
            <h2>{productOption.group_name}: {productOption.name}</h2>
            <span className="description">{color} ({productOption.description})</span>
            <span className="brand-code">{productOption.brand_code}</span>
            <span>
            <Button>Remove</Button>
            <Button
              to={`/admin/brand/${brandToken}/product/${product.token}/option/${productOption.token}/edit`}>Edit</Button>
          </span>
          </div>
          <div className="product-option-children">{children}</div>
        </div>
      );
    });

  return (ret);
}

export function getTopLevelOptions(options) {
  let defaultOptionValues = [{key: 'optionValues-0', value: {name: DEFAULT_OPTION_NAME}}];
  if (!options) {
    return {optionName: DEFAULT_OPTION_NAME, optionValues: defaultOptionValues};
  }

  let optionValues = options.filter((o) => {
    return !o.parent_token;
  }).map((o, index) => {
    const key = `option-${index}-${Date.now()}`;
    return {key: o.token || key, value: o};
  });


  // Invalid options, must be level of no parent_token set; return default case
  if (!optionValues || optionValues.length === 0) {
    return {optionName: DEFAULT_OPTION_NAME, optionValues: defaultOptionValues};
  }

  let optionName = optionValues
    .reduce((acc, optionValue) => {
      return optionValue.value.group_name || acc;
    }, DEFAULT_OPTION_NAME);

  return {
    optionName,
    optionValues
  };
}

const ErrorPrefix = 'ErrorPrefix';
export function getErrorKey(fieldName) {
  return `${ErrorPrefix}_${fieldName}`;
}

export function createAlertMessage(error) {
  let messages = [];
  messages.push(`Status: ${error.httpStatusCode}`);
  messages.push(`Message: ${JSON.stringify(error.message || (error.response && error.response.message))}`);
  return messages.join('\n');
}


/** WEBPACK FOOTER **
 ** ./src/lib/AdminFunctions.js
 **/